import {
  faSoapNote,
  faMultipetNote,
  faPackModeNote,
  faRecapNote,
  faCallbackNote,
  faDictationNote,
  faDentalNote,
  faUltrasoundNote,
} from "@awesome.me/kit-0572d5a008/icons/kit/custom";

export const DEFAULT_RECORDING_TYPE = {
  value: "medical_record",
  name: "Medical Record",
  icon: faSoapNote,
  description:
    "Select 'Medical Record' to generate an automatic SOAP note for your patient.",
};

export const SCRIBENOTE_DEFAULTS = [
  {
    name: "Medical Record",
    icon: faSoapNote,
    description: "Standard SOAP note.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "medical_record",
  },
  {
    name: "Multi-Pet SOAP",
    icon: faMultipetNote,
    description: "SOAP note for 2-3 patients.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "multipet",
  },
  {
    name: "Pack Mode SOAP",
    icon: faPackModeNote,
    description: "SOAP note for 4+ patients.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "packmode",
  },
  {
    name: "Callback",
    icon: faCallbackNote,
    description: "Short summary of your call with a client.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "callback",
  },
  {
    name: "Dental Record",
    icon: faDentalNote,
    description:
      "Visual dental chart based on tooth-by-tooth dictation.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "dental_record",
  },
  {
    name: "Recap",
    icon: faRecapNote,
    description:
      "Summary of meetings or any other recordings in concise bullet points.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "recap",
  },
  {
    name: "Dictation",
    icon: faDictationNote,
    description: "Direct transcript of your recording.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "dictation",
  },
  {
    name: "Abd. Ultrasound",
    icon: faUltrasoundNote,
    description:
      "Summary of organ findings based on an abdominal ultrasound.",
    templateType: "SCRIBENOTE_DEFAULT",
    value: "abdominal_ultrasound",
  },
];
